<mat-sidenav-container>
  <mat-sidenav #sidenav [mode]="'over'">
    <app-sidenav-content></app-sidenav-content>
  </mat-sidenav>

  <mat-sidenav-content>
    <app-header
      (isHandsetPortraitStatus)="isHandsetPortraitStatus($event)"
      (openSideNav)="sidenav.toggle()"
    ></app-header>
    <div class="sggs-dashboard-content">
      <div class="small-carousel carousel-wrapper" [class.is-mobile]="isHandsetPortrait">
        <div class="title-banner-wrapper {{bannerClass}}" style="background-image: url('assets/images/{{bannerImage}}');">
          <h1 class="bani-title mb-0">
            {{ activeLanguageTranslations?.title }}
          </h1>
        </div>
      </div>
      <div class="padded-content-wrapper" [class.is-mobile]="isHandsetPortrait">
        <!-- <div class="static-content-heading-wrapper">{{ activeLanguageTranslations?.title }}</div> -->
        <div class="static-content-paragraph">
          <!-- <b> {{ activeLanguageTranslations?.sggsProject }} </b> <br />
          {{ activeLanguageTranslations?.subTagLine }} -->
        </div>

        <!-- <div class="static-content-heading-wrapper">{{ activeLanguageTranslations?.theVision }}</div> -->
        <div class="static-content-paragraph">
          <b>{{ activeLanguageTranslations?.sggsProject }}</b> <br/><br/>
          {{ activeLanguageTranslations?.paragraph1  }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.paragraph2 }}
          <a href="{{ activeLanguageTranslations?.link2_1  }}" target="_blank" class="view-more-link">{{ activeLanguageTranslations?.link2_1  }}</a>
          {{ activeLanguageTranslations?.paragraph2_1  }}
        </div>
         
         <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.paragraph3 }}<br/>
          {{ activeLanguageTranslations?.paragraph3_1 }}<br/>
          {{ activeLanguageTranslations?.paragraph3_2 }}
         </div>


         <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.paragraph4 }}<br/>
          {{ activeLanguageTranslations?.paragraph4_1 }}<br/>
          {{ activeLanguageTranslations?.paragraph4_2 }}
         </div>
         <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.paragraph5 }}
         </div>
         <div class="static-content-paragraph">
          <b>{{ activeLanguageTranslations?.paragraph6 }}</b><br/><br/>
          {{ activeLanguageTranslations?.paragraph7 }}<a class="know-more" href="mailto:{{activeLanguageTranslations?.mail_link}} ">{{activeLanguageTranslations?.mail_link}} </a>
         </div>
         <div class="static-content-paragraph">
          <b>{{ activeLanguageTranslations?.paragraph8 }}</b>
         </div>
         <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.paragraph9 }}<br/>
          {{ activeLanguageTranslations?.paragraph9_1 }}<br/>
          {{ activeLanguageTranslations?.paragraph9_2 }}<br/>
          {{ activeLanguageTranslations?.paragraph9_3 }}
         </div>
         <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.paragraph10 }}<br/>
          {{ activeLanguageTranslations?.paragraph10_1 }}<br/>
          {{ activeLanguageTranslations?.paragraph10_2 }}
         </div>
         <div class="static-content-paragraph">
          <b>{{ activeLanguageTranslations?.paragraph11 }}</b><br/><br/>
             {{ activeLanguageTranslations?.paragraph11_1 }}<br/>
             {{ activeLanguageTranslations?.paragraph11_2 }}<br/>
             {{ activeLanguageTranslations?.paragraph11_3 }}<br/>
             {{ activeLanguageTranslations?.paragraph11_4 }}<br/>
             {{ activeLanguageTranslations?.paragraph11_5 }}<br/>
             {{ activeLanguageTranslations?.paragraph11_6 }}
         </div>
         <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.paragraph12 }}
         </div>
         <div class="static-content-paragraph">
          <b>{{ activeLanguageTranslations?.paragraph13 }}</b><br/><br/>
          {{ activeLanguageTranslations?.paragraph13_1 }}<br/>
          {{ activeLanguageTranslations?.paragraph13_2 }}<br/>
          {{ activeLanguageTranslations?.paragraph13_3 }}<br/>
         </div>
         <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.paragraph14 }}<br/>
          {{ activeLanguageTranslations?.paragraph14_1 }}<br/>
          {{ activeLanguageTranslations?.paragraph14_2}}<br/>
          {{ activeLanguageTranslations?.paragraph14_3 }}<br/>
          {{ activeLanguageTranslations?.paragraph14_4 }}<br/>
         </div>
         <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.paragraph15 }}<br/>
          {{ activeLanguageTranslations?.paragraph15_1 }}<br/>
          {{ activeLanguageTranslations?.paragraph15_2 }}<br/>
         </div>
         <div class="static-content-paragraph">
          <b>{{ activeLanguageTranslations?.paragraph16 }}</b><br/><br/>
          {{ activeLanguageTranslations?.paragraph17 }}<br/>
          {{ activeLanguageTranslations?.paragraph18 }}<br/>
          {{ activeLanguageTranslations?.paragraph19 }}
         </div>
         <div class="static-content-paragraph">
          <b>{{ activeLanguageTranslations?.paragraph20 }}</b><br/><br/>
          {{ activeLanguageTranslations?.paragraph21 }}<br/>
          {{ activeLanguageTranslations?.paragraph21_1 }}<br/>
          {{ activeLanguageTranslations?.paragraph21_2 }}<br/>
          {{ activeLanguageTranslations?.paragraph21_3 }}<br/>
          {{ activeLanguageTranslations?.paragraph21_4 }}<br/>
          {{ activeLanguageTranslations?.paragraph21_5 }}<br/>
          {{ activeLanguageTranslations?.paragraph21_6 }}<br/>
          {{ activeLanguageTranslations?.paragraph21_7 }}<br/>
         </div>
         <div class="static-content-paragraph">
          <b>{{ activeLanguageTranslations?.paragraph22 }}</b><br/><br/>
          {{ activeLanguageTranslations?.paragraph23 }}<br/>
          {{ activeLanguageTranslations?.paragraph24 }}<br/>
          {{ activeLanguageTranslations?.paragraph24_1 }}<br/>
          {{ activeLanguageTranslations?.paragraph24_2 }}<br/>
          {{ activeLanguageTranslations?.paragraph24_3 }}<br/>
          {{ activeLanguageTranslations?.paragraph24_4 }}<br/>
          {{ activeLanguageTranslations?.paragraph24_5 }}<br/>
          {{ activeLanguageTranslations?.paragraph24_6 }}<br/>
         </div>
         <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.paragraph25 }}<br/>
          {{ activeLanguageTranslations?.paragraph25_1 }}<br/>
          {{ activeLanguageTranslations?.paragraph25_2 }}<br/>
         </div>
         <div class="static-content-paragraph">
          <b>{{ activeLanguageTranslations?.paragraph26 }}</b><br/><br/>
          {{ activeLanguageTranslations?.paragraph27 }}<br/>
          {{ activeLanguageTranslations?.paragraph27_1 }}<br/><br/>
          {{ activeLanguageTranslations?.paragraph28 }}<br/>

         </div>
         <div class="static-content-paragraph">
          <b>{{ activeLanguageTranslations?.paragraph29 }}</b><br/><br/>
          {{ activeLanguageTranslations?.paragraph30 }} 
          <a class="know-more" href="mailto:{{activeLanguageTranslations?.mail_link}} ">{{activeLanguageTranslations?.mail_link}} </a>
          {{ activeLanguageTranslations?.paragraph30_1 }}<br/>
          {{ activeLanguageTranslations?.paragraph31 }}
          </div>
          <div class="static-content-paragraph">
          <b>{{ activeLanguageTranslations?.paragraph32 }}</b><br/><br/>
          {{ activeLanguageTranslations?.paragraph33 }} <a class="know-more" href="mailto:{{activeLanguageTranslations?.mail_link}} ">{{activeLanguageTranslations?.mail_link}} </a>
          {{ activeLanguageTranslations?.paragraphAt }}<br/><br />
          {{ activeLanguageTranslations?.paragraph33_1 }}<br/>
          {{ activeLanguageTranslations?.paragraph33_2 }}<br/>
         </div>
         <div class="static-content-paragraph">
          <b>{{ activeLanguageTranslations?.paragraph34 }}</b><br/><br/>
          {{ activeLanguageTranslations?.paragraph35 }}<br/><br/>
          {{ activeLanguageTranslations?.paragraph36 }}<br/>
         </div>
         <div class="static-content-paragraph">
          <b>{{ activeLanguageTranslations?.paragraph37 }}</b><br/><br/>
          {{ activeLanguageTranslations?.paragraph38 }}<br/>
         </div>
         <div class="static-content-paragraph">
          <b>{{ activeLanguageTranslations?.paragraph39 }}</b><br/><br/>
          {{ activeLanguageTranslations?.paragraph40 }} <a class="know-more" href="mailto:{{activeLanguageTranslations?.mail_link}} ">{{activeLanguageTranslations?.mail_link}} </a><br/><br/>
          {{ activeLanguageTranslations?.paragraph41 }}<br/>
          <a href="{{ activeLanguageTranslations?.paragraph42 }}" target="_blank" class="view-more-link"> {{ activeLanguageTranslations?.paragraph42 }}</a><br/>
          {{ activeLanguageTranslations?.paragraph43 }}<br/><br/>
          {{ activeLanguageTranslations?.paragraph44 }}<br/>
         </div>        

        
      </div>
      <app-footer [isHandsetPortrait]="isHandsetPortrait"></app-footer>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
